import CryptoJS from "crypto-js";

const secretKey =  process.env.REACT_APP_SECRET_KEY;
// Function to generate a random 16-character IV
const generateRandomIV = () => {
  let iv = "";
  const possibleChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  for (let i = 0; i < 16; i++) {
    iv += possibleChars.charAt(Math.floor(Math.random() * possibleChars.length));
  }
  return iv;
};

// Function to encrypt the payload with a random IV
export const encryptPayload = (payload) => {
  try {
    const stringPayload = JSON.stringify(payload);
    const iv = generateRandomIV(); // Generate random IV
    const encrypted = CryptoJS.AES.encrypt(stringPayload, CryptoJS.enc.Utf8.parse(secretKey), {
      iv: CryptoJS.enc.Utf8.parse(iv), // Use raw IV
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    return {
      iv, // Raw IV (16-character string)
      encryptedData: encrypted.toString(),
    };
  } catch (error) {
    console.error("Error encrypting payload:", error);
    return null;
  }
};

// Function to decrypt the payload using the provided IV
export const decryptPayload = (encryptedPayload, iv) => {
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedPayload, CryptoJS.enc.Utf8.parse(secretKey), {
      iv: CryptoJS.enc.Utf8.parse(iv),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    const decryptedString = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedString);
  } catch (error) {
    console.error("Error decrypting payload:", error.status);
    return null;
  }
};

export const encryptAES = (payload, key, iv) => {
  try {
    const stringPayload = JSON.stringify(payload);

    const iv = generateRandomIV(); // Generate random IV
    const encrypted = CryptoJS.AES.encrypt(
      stringPayload,
      CryptoJS.enc.Utf8.parse(secretKey),
      {
        iv: CryptoJS.enc.Utf8.parse(iv), // Use raw IV
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );

    return {
      iv, // Raw IV (16-character string)
      encryptedData: encrypted.toString(),
    };
  } catch (error) {
    console.error("Error encrypting payload:", error);
    return null;
  }
};

export const decryptAES = (encryptedPayload, iv) => {
  try {
    const bytes = CryptoJS.AES.decrypt(
      encryptedPayload,
      CryptoJS.enc.Utf8.parse(secretKey),
      {
        iv: CryptoJS.enc.Utf8.parse(iv),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );

    const decryptedString = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedString);
  } catch (error) {
    console.error("Error decrypting payload:", error);
    return null;
  }
};
